export default __webpack_public_path__ + "static/media/semaforo luz roja.281396dc.svg";